import {Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ToothUiManagerModel} from './tooth-ui-manager.model';
import {ToothUiManagerService} from './tooth-ui-manager.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-tooth-base',
  template: `<div style='pointer-events: none;'></div>`
})

export class ToothBaseComponent implements OnDestroy {
  @Output() toothSelectEvent = new EventEmitter<ToothUiManagerModel>();
  name;
  viewToothNumber;
  show = false;
  uiModel: ToothUiManagerModel;
  models: ToothUiManagerModel[];
  isReady = false;
  subscriptions: Subscription = new Subscription();

  // 1 = Upper mouth, 2 = bottom mouth
  toothPositionV: number = 1;
  // 1-16 for upper left to right
  // 16-1 for bottom right to left
  toothPositionH: number;

  constructor(private elRef: ElementRef, protected tpService: ToothUiManagerService) {
    this.name = this.elRef.nativeElement.tagName.replace('APP-', '').toLowerCase();

    // 1-16 position is TOP mouth from Left to right.  17-32 is Bottom mouth from right to left.
    // Once above 16, to match with the db we must go 16,15,14... etc.
    this.viewToothNumber = parseInt(this.name.replace('tooth-', ''));
    this.toothPositionH = this.viewToothNumber;
    if (this.viewToothNumber > 16) {
      const diff = this.viewToothNumber - 16;
      const offset = (diff * 2) - 1;
      this.viewToothNumber = this.viewToothNumber - offset;
      this.toothPositionH = this.viewToothNumber;
      this.toothPositionV = 2;
    }

    const sub1 = this.tpService.selectionSubject.subscribe((model) => {
      if (this.uiModel.toothModel.ToothId === model.toothModel.ToothId) {
        this.show = model.isSelected;      }
    });
    this.subscriptions.add(sub1);

    const sub2 = this.tpService.modelLoadedSubject.subscribe((models) => {
      this.models = models.concat();
      for (const model of this.models) {
        if (model.toothModel.PhysicalVorder === this.toothPositionV && model.toothModel.PhysicalHorderLR === this.toothPositionH) {
          this.uiModel = model;
        }
      }
    });
    this.subscriptions.add(sub2);
    this.tpService.childViewLoadedSubject.next();
  }

  toothClick(event) {
    if (event.target.id === this.name) {
      this.show = !this.show;
      this.uiModel.isSelected = this.show;
      this.toothSelectEvent.emit(this.uiModel);
    } else {
      event.stopPropagation();
    }
  }

  get notation() {
    return this.uiModel.toothModel.cfgToothDescriptions[0].Notation;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
